import { createSlice } from '@reduxjs/toolkit';
import type {PayloadAction} from "@reduxjs/toolkit"

const TexturesSlice = createSlice({
	name: "textures",
	initialState: {
		textures: {}
	},
	reducers: {
		addTexture(state, action: PayloadAction<{ id: string, name: string }>)
		{
			state.textures[action.payload.id].name = action.payload.name;
		},
		removeTexture(state, action: PayloadAction<{ id: string }>)
		{
			delete state.textures[action.payload.id];
		},
		renameTexture(state, action: PayloadAction<{ id: string, name: string }>)
		{
			state.textures[action.payload.id].name = action.payload.name;
		},
	},
});

export default TexturesSlice;
